import React, { useContext, useEffect, useState } from 'react';
import PrintIcon from '@mui/icons-material/Print';
import * as S from './styles';
import TableBasic from '../../../../../components/newStudent/Table';
import ButtonIcon from '../../../../../components/newStudent/Buttons/ButtonIcon';
import { ButtonSimple } from '../../../../../components/newStudent/Buttons';
import { AletNotfoundLoading } from '../../../../../components/newStudent/Alert';
import {
  INewStudentProvider,
  NewStudentProviderContext,
} from '../../../../../components/newStudent/ProviderNewStudent';
import { certificateServiceNewStudent } from '../../../../../services/newStudent';
import { IDisciplineCertificate } from '../../../../../services/newStudent/certificate/certificate.service';
import { formatDecimal } from '../../../../../util/common/appUtil';

export default function DisciplineCertificates() {
  const { setIsLoading } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;
  const [items, setItems] = useState<IDisciplineCertificate[]>([]);

  const load = async () => {
    setIsLoading(true);
    try {
      const { data, result } = await certificateServiceNewStudent.showDisciplines();
      setItems(result && Array.isArray(data) ? data : []);
    } catch (error) {
      throw new Error(String(error));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleIssue = async (gradeId: number) => {
    setIsLoading(true);
    try {
      const { result, data } = await certificateServiceNewStudent.createDiscipline(gradeId);
      if (result && data?.url) {
        window.open(data.url);
      }
      if (result) {
        await load();
      }
    } catch (error) {
      throw new Error(String(error));
    } finally {
      setIsLoading(false);
    }
  };

  const dataTable = {
    title: [
      { item: <h5>Disciplina</h5> },
      { item: <h5>Certificado</h5>, align: 'center' },
    ],
    content: items.map((item) => ({
      discipline: {
        item: (
          <S.RowTableDiv>
            <S.Key>{item.disciplineName}</S.Key>
            <S.Value>
              {item.courseName ? `${item.courseName} • ` : ''}
              {item.workload} horas
              {item.grade !== null ? ` • Nota ${formatDecimal(item.grade)}` : ''}
            </S.Value>
          </S.RowTableDiv>
        ),
      },
      certificate: {
        item: item.url ? (
          <ButtonIcon
            icon={<PrintIcon fontSize="large" />}
            color="success"
            onClick={() => window.open(item.url!)}
          />
        ) : item.canIssue ? (
          <ButtonSimple
            color="primary"
            heightSize="small"
            widthSize="small"
            onClick={() => handleIssue(item.gradeId)}
          >
            Emitir
          </ButtonSimple>
        ) : (
          item.blockReason || 'Indisponível'
        ),
        align: 'center',
      },
    })),
  };

  return (
    <S.Container>
      {items.length <= 0 ? (
        <AletNotfoundLoading toRender />
      ) : (
        <TableBasic data={dataTable} />
      )}
    </S.Container>
  );
}
